import { useMemo } from 'react';
import { DownloadCheckboxKey } from '../../../../utils/common';
import { IMarker } from '../../../../types/marker';

export const useDatasetAvailability = (activePoint?: IMarker | null) => {
  const category = useMemo<string>(() => {
    return activePoint?.activeDatasetKey ?? DownloadCheckboxKey.SW;
  }, [activePoint?.activeDatasetKey]);

  const isDatasetOffline = useMemo<boolean>(() => {
    return activePoint?.isDatasetOffline?.[category] ?? false;
  }, [category, activePoint?.isDatasetOffline]);

  const isDatasetHasReport = useMemo<boolean>(() => {
    return activePoint?.isDatasetHasReport?.[category] ?? false;
  }, [category, activePoint?.isDatasetHasReport]);

  return {
    category,
    isDatasetOffline,
    isDatasetHasReport,
  };
};
